import Swal from "sweetalert2";

const CONFIRM_COLOR = "rgb(208 125 63)";

const fireAlert = ({ icon, title, text }) =>
  Swal.fire({
    icon,
    title,
    text,
    confirmButtonColor: CONFIRM_COLOR,
  });

export const showSuccessAlert = (title, text = "") =>
  fireAlert({ icon: "success", title, text });

export const showErrorAlert = (title, text = "") =>
  fireAlert({ icon: "error", title, text });

export const showWarningAlert = (title, text = "") =>
  fireAlert({ icon: "warning", title, text });

export const showInfoAlert = (title, text = "") =>
  fireAlert({ icon: "info", title, text });

export const showDeleteConfirm = async ({
  title = "Delete?",
  text = "",
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
} = {}) => {
  const result = await Swal.fire({
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: CONFIRM_COLOR,
    reverseButtons: true,
  });
  return result.isConfirmed;
};
